




// old code this is 


// import React, { useState, useEffect } from "react";
// import { useNavigate, useLocation } from "react-router-dom";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import axios from "axios";

// function UpdateVehicles() {
//   const navigate = useNavigate();
//   const location = useLocation();

//   // ✅ Pre-filled data from navigation
//   const vehicleData = location.state?.vehicleData || {};

//   // ✅ State for form fields
//   const [vehicleNo, setVehicleNo] = useState(vehicleData.VehicleNo || "");
//   const [vehicleTypeID, setVehicleTypeID] = useState(vehicleData.VehicleTypeID || ""); // Use ID for dropdown
//   const [ownerID, setOwnerID] = useState(vehicleData.OwnerID || "");
//   const [modelYear, setModelYear] = useState(vehicleData.ModelYear || "");

//   // Dropdown data
//   const [vehicleTypes, setVehicleTypes] = useState([]);
//   const [owners, setOwners] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const BASE_REST_API_URL = process.env.REACT_APP_BASE_REST_API_URL;
//   const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;

//   // ✅ Fetch dropdown data for Vehicle Types & Owners
//   useEffect(() => {
//     const fetchDropdowns = async () => {
//       try {
//         // const res = await axios.get("http://localhost:5000/api/vehicles/dropdowns");
//         // const response = await axios.get("https://etour.responseinfoway.com/api/vehicles/dropdowns");
//         const response = await axios.get(`${BASE_API_URL}/vehicles/dropdowns`);

//         // Sort alphabetically
//         const sortedOwners = response.data.owners.sort((a, b) =>
//           a.OwnerName.localeCompare(b.OwnerName)
//         );
//         const sortedVehicleTypes = response.data.vehicleTypes.sort((a, b) =>
//           a.VehicleTypeName.localeCompare(b.VehicleTypeName)
//         );

//         setOwners(sortedOwners);
//         setVehicleTypes(sortedVehicleTypes);
//       } catch (err) {
//         console.error("Error fetching dropdown data:", err);
//         toast.error("Failed to load dropdowns");
//       }
//     };
//     fetchDropdowns();
//   }, []);

//   // ✅ Ensure pre-filled data is always updated when vehicleData changes
//   useEffect(() => {
//   if (vehicleData) {
//     setVehicleNo(vehicleData.VehicleNo || "");
//     setVehicleTypeID(vehicleData.VehicleTypeID || ""); // ✅ pre-fill ID
//     setOwnerID(vehicleData.OwnerID || "");
//     setModelYear(vehicleData.ModelYear || "");
//   }
// }, [vehicleData]);


//   // ✅ Handle form submit
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     try {
//       const payload = {
//         vehicleNumber: vehicleNo,
//         vehicleType: vehicleTypeID, // Send ID to backend
//         ownerID: ownerID,           // Send ID to backend
//         modelYear: modelYear,
//       };

//       console.log("🚀 Submitting updated vehicle payload:", payload);

//       // await axios.put(`http://localhost:5000/api/vehicles/${vehicleData.ID}`, payload);
//       // await axios.put(`https://etour.responseinfoway.com/api/vehicles/${vehicleData.ID}`, payload);
//       await axios.put(`${BASE_API_URL}/vehicles/${vehicleData.ID}`, payload);
//       toast.success("Vehicle updated successfully!");
//       // Redirect to /Vehicles after success
//       setTimeout(() => navigate("/Vehicles"), 1200);
//     } catch (err) {
//       console.error("❌ Failed to update vehicle:", err);
//       toast.error(err.response?.data?.error || "Failed to update vehicle");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="compney_container">
//       <ToastContainer position="top-center" autoClose={2000} />
//       <form className="compney_form" onSubmit={handleSubmit}>
//         <h5 className="text-center font-bold m-3">Update Vehicle</h5>

//         {/* Vehicle Number */}
//         <div className="compney_input_div">
//           <label>Vehicle Number</label>
//           <input
//             type="text"
//             placeholder="Enter Vehicle Number"
//             required
//             value={vehicleNo}
//             onChange={(e) => setVehicleNo(e.target.value.toUpperCase())}
//           />
//         </div>

//         {/* Vehicle Type Dropdown */}
//         <div className="compney_input_div">
//           <label>Vehicle Type</label>
//           <select
//             value={vehicleTypeID} // <-- this should be the ID
//             onChange={(e) => setVehicleTypeID(e.target.value)}
//             required
//           >
//             <option value="">Select Vehicle Type</option>
//             {vehicleTypes.map((vt) => (
//               <option key={vt.VehicleTypeID} value={vt.VehicleTypeID}>
//                 {vt.VehicleTypeName}
//               </option>
//             ))}
//           </select>
//         </div>


//         {/* Owner Name Dropdown */}
//         <div className="compney_input_div">
//           <label>Owner Name</label>
//           <select
//             value={ownerID}
//             onChange={(e) => setOwnerID(e.target.value)}
//             required
//           >
//             <option value="">Select Owner</option>
//             {owners.map((o) => (
//               <option key={o.HEAD_CODE} value={o.HEAD_CODE}>
//                 {o.OwnerName}
//               </option>
//             ))}
//           </select>
//         </div>

//         {/* Model Year */}
//         <div className="compney_input_div">
//           <label>Model Year</label>
//           <input
//             type="number"
//             placeholder="Enter Model Year"
//             required
//             value={modelYear}
//             onChange={(e) => setModelYear(e.target.value)}
//           />
//         </div>

//         {/* Submit Button */}
//         <button type="submit" disabled={loading}>
//           {loading ? "Updating..." : "Update Vehicle"}
//         </button>
//       </form>
//     </div>
//   );
// }

// export default UpdateVehicles;





// this is the upadted code


import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { showToast } from "../../../utils/customToast";
import axios from "axios";
import { apiWithLog } from "../../../utils/apiWithLog";
import "../Ledger/UpdateLedger.css";

function UpdateVehicles() {
  const navigate = useNavigate();
  const location = useLocation();

  // Prefilled data
  const vehicleData = location.state?.vehicleData || {};

  const [vehicleNo, setVehicleNo] = useState(vehicleData.VehicleNo || vehicleData.vehicleNo || "");
  const [vehicleTypeID, setVehicleTypeID] = useState(
    vehicleData.VehicleTypeID != null
      ? String(vehicleData.VehicleTypeID)
      : vehicleData.CarId != null
      ? String(vehicleData.CarId)
      : ""
  );
  const [ownerID, setOwnerID] = useState(
    vehicleData.OwnerID != null
      ? String(vehicleData.OwnerID)
      : vehicleData.Head_Code != null
      ? String(vehicleData.Head_Code)
      : ""
  );
  const [modelYear, setModelYear] = useState(vehicleData.ModelYear || vehicleData.modelYear || "");
  const [self, setSelf] = useState(
    vehicleData.Self != null ? (Number(vehicleData.Self) === 1 ? 1 : 0) : 0
  );

  const [vehicleTypes, setVehicleTypes] = useState([]);
  const [owners, setOwners] = useState([]);
  const [loading, setLoading] = useState(false);
  const [compID, setCompID] = useState(null);

  const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;

  // 🔹 Get CompID & watch for changes
  useEffect(() => {
    const company = JSON.parse(localStorage.getItem("selectedCompany"));
    if (company?.id) setCompID(company.id);

    const interval = setInterval(() => {
      const updated = JSON.parse(localStorage.getItem("selectedCompany"));
      if (updated?.id && updated.id !== compID) setCompID(updated.id);
    }, 500);

    return () => clearInterval(interval);
  }, [compID]);

  // 🔹 Load dropdowns when CompID changes
  useEffect(() => {
    const fetchDropdowns = async () => {
      try {
        if (!compID) return;

        const res = await axios.get(
          `${BASE_API_URL}/vehicles/dropdowns/${compID}`
        );

        if (!res.data.success) return;

        const sortedOwners = (res.data.owners || []).sort((a, b) =>
          (a.OwnerName || a.HEADName || "").localeCompare(b.OwnerName || b.HEADName || "")
        );
        const sortedVehicleTypes = (res.data.vehicleTypes || []).sort((a, b) =>
          (a.VehicleTypeName || a.VTYPE || "").localeCompare(b.VehicleTypeName || b.VTYPE || "")
        );

        setOwners(sortedOwners);
        setVehicleTypes(sortedVehicleTypes);

        // Pre-fill or sync vehicleTypeID if not already set or matched by name
        if (vehicleData.VehicleTypeID != null && vehicleData.VehicleTypeID !== "") {
          setVehicleTypeID(String(vehicleData.VehicleTypeID));
        } else if (vehicleData.CarId != null && vehicleData.CarId !== "") {
          setVehicleTypeID(String(vehicleData.CarId));
        } else if (vehicleData.VehicleTypeName || vehicleData.VehicleType || vehicleData.VTYPE) {
          const targetName = (vehicleData.VehicleTypeName || vehicleData.VehicleType || vehicleData.VTYPE || "").trim().toLowerCase();
          const match = sortedVehicleTypes.find(
            (vt) => (vt.VehicleTypeName || vt.VTYPE || "").trim().toLowerCase() === targetName
          );
          if (match) {
            setVehicleTypeID(String(match.VehicleTypeID || match.ID));
          }
        }

        if (vehicleData.OwnerID != null && vehicleData.OwnerID !== "") {
          setOwnerID(String(vehicleData.OwnerID));
        } else if (vehicleData.Head_Code != null && vehicleData.Head_Code !== "") {
          setOwnerID(String(vehicleData.Head_Code));
        }
      } catch (err) {
        console.error("Dropdown fetch error:", err);
        showToast.error("Failed to load dropdowns");
      }
    };

    fetchDropdowns();
  }, [compID]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;

    if (!vehicleNo || !vehicleNo.trim()) {
      showToast.warn("Please enter a Vehicle Number");
      return;
    }

    if (!vehicleTypeID) {
      showToast.warn("Please select a Vehicle Type");
      return;
    }

    if (!ownerID) {
      showToast.warn("Please select an Owner");
      return;
    }

    setLoading(true);

    try {
      const company = JSON.parse(localStorage.getItem("selectedCompany"));

      if (!company?.id && !compID) {
        showToast.warn("Please select a company first.");
        setLoading(false);
        return;
      }

      const payload = {
        vehicleNumber: vehicleNo.trim(),
        vehicleType: vehicleTypeID,
        ownerID: ownerID,
        modelYear: modelYear ? parseInt(modelYear) : null,
        self: parseInt(self) === 1 ? 1 : 0,
        Self: parseInt(self) === 1 ? 1 : 0,
        CompID: company?.id || compID
      };

      // ============================
      // API with Logging (Node)
      // ============================
      const res = await apiWithLog({
        method: "PUT",
        url: `${BASE_API_URL}/vehicles/${vehicleData.ID}`,
        data: payload,
        module: "VehicleMaster",
        action: "E",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const result = res.data;

      if ((res.status === 200 || res.status === 201) && (result?.status || result?.success)) {
        showToast.save("Vehicle updated successfully!");
        setTimeout(() => navigate("/Vehicles"), 1200);
      } else {
        showToast.error(result?.message || "Failed to update vehicle");
      }

    } catch (err) {
      console.error("Failed to update vehicle:", err);
      showToast.error(
        err?.response?.data?.message ||
        err?.response?.data?.error ||
        "Failed to update vehicle"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="update_ledger_container">
      {/* Header & Breadcrumbs */}
      <div className="update_ledger_header_bar">
        <div className="update_ledger_title_group">
          <h4 className="update_ledger_title">Update Vehicle</h4>
          <div className="update_ledger_breadcrumbs">
            <Link to="/home">Home</Link>
            <span>/</span>
            <Link to="/Vehicles">Vehicles</Link>
            <span>/</span>
            <span>Update</span>
          </div>
        </div>
      </div>

      {/* Form Card */}
      <div className="update_ledger_card">
        <div className="update_ledger_card_header">
          <h5>Vehicle Information</h5>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="update_ledger_grid">
            <div className="update_ledger_field">
              <label htmlFor="vehicleNo">
                Vehicle Number <span className="required">*</span>
              </label>
              <input
                id="vehicleNo"
                type="text"
                value={vehicleNo}
                placeholder="e.g. RJ14TC1234"
                onChange={(e) => setVehicleNo(e.target.value.toUpperCase())}
                required
              />
            </div>

            <div className="update_ledger_field">
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "6px" }}>
                <label htmlFor="vehicleTypeID" style={{ margin: 0 }}>
                  Vehicle Type <span className="required">*</span>
                </label>
                <Link
                  to="/vehicletype"
                  style={{
                    fontSize: "12px",
                    color: "#0f766e",
                    fontWeight: "600",
                    textDecoration: "none",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "4px"
                  }}
                  title="Add New Vehicle Type"
                >
                  <i className="fa-solid fa-plus-circle"></i> + Add Vehicle Type
                </Link>
              </div>
              <select
                id="vehicleTypeID"
                value={String(vehicleTypeID || "")}
                onChange={(e) => setVehicleTypeID(e.target.value)}
                required
              >
                <option value="">-- Select Vehicle Type --</option>
                {vehicleTypes.map((vt) => {
                  const val = String(vt.VehicleTypeID || vt.ID || "");
                  const label = vt.VehicleTypeName || vt.VTYPE || "";
                  return (
                    <option key={val} value={val}>
                      {label}
                    </option>
                  );
                })}
              </select>
            </div>

            <div className="update_ledger_field">
              <label style={{ marginBottom: "6px" }}>
                Ownership <span className="required">*</span>
              </label>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  background: "#f1f5f9",
                  padding: "3px",
                  borderRadius: "6px",
                  border: "1px solid #cbd5e1",
                  height: "38px",
                  boxSizing: "border-box",
                  width: "100%",
                }}
              >
                <button
                  type="button"
                  onClick={() => setSelf(1)}
                  style={{
                    flex: 1,
                    height: "100%",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                    fontSize: "13px",
                    fontWeight: self === 1 ? "700" : "500",
                    backgroundColor: self === 1 ? "#0f766e" : "transparent",
                    color: self === 1 ? "#ffffff" : "#475569",
                    boxShadow: self === 1 ? "0 1px 3px rgba(0,0,0,0.12)" : "none",
                    transition: "all 0.15s ease",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "6px",
                  }}
                >
                  <i className="fa-solid fa-car" style={{ fontSize: "12px" }}></i> Self
                </button>
                <button
                  type="button"
                  onClick={() => setSelf(0)}
                  style={{
                    flex: 1,
                    height: "100%",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                    fontSize: "13px",
                    fontWeight: self === 0 ? "700" : "500",
                    backgroundColor: self === 0 ? "#0f766e" : "transparent",
                    color: self === 0 ? "#ffffff" : "#475569",
                    boxShadow: self === 0 ? "0 1px 3px rgba(0,0,0,0.12)" : "none",
                    transition: "all 0.15s ease",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "6px",
                  }}
                >
                  <i className="fa-solid fa-users" style={{ fontSize: "12px" }}></i> Others
                </button>
              </div>
            </div>

            <div className="update_ledger_field">
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "6px" }}>
                <label htmlFor="ownerID" style={{ margin: 0 }}>
                  Owner Name <span className="required">*</span>
                </label>
                <Link
                  to="/AddLedger"
                  state={{ defaultGroup: 23, defaultGroupName: "Sundry Creditors", fromVehicle: true }}
                  style={{
                    fontSize: "12px",
                    color: "#0f766e",
                    fontWeight: "600",
                    textDecoration: "none",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "4px"
                  }}
                  title="Add New Owner (Sundry Creditors)"
                >
                  <i className="fa-solid fa-plus-circle"></i> + Add Owner
                </Link>
              </div>
              <select
                id="ownerID"
                value={String(ownerID || "")}
                onChange={(e) => setOwnerID(e.target.value)}
                required
              >
                <option value="">-- Select Owner (Sundry Creditor) * --</option>
                {owners.map((o) => {
                  const val = String(o.HEAD_CODE || o.OwnerID || "");
                  const label = o.OwnerName || o.HEADName || "";
                  return (
                    <option key={val} value={val}>
                      {label}
                    </option>
                  );
                })}
              </select>
            </div>

            <div className="update_ledger_field">
              <label htmlFor="modelYear">
                Model Year
              </label>
              <input
                id="modelYear"
                type="number"
                value={modelYear}
                placeholder="e.g. 2024 (Optional)"
                onChange={(e) => setModelYear(e.target.value)}
              />
            </div>
          </div>

          <div className="update_ledger_actions">
            <Link to="/Vehicles" className="update_ledger_cancel_btn">
              Cancel
            </Link>
            <button
              type="submit"
              className="update_ledger_submit_btn"
              disabled={loading}
            >
              {loading ? "Updating..." : "Update Vehicle"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default UpdateVehicles;








